import { useCallback, useEffect, useRef, useState } from 'react';
import { Heart } from 'lucide-react';

const COLORS = ['#f43f5e', '#fb7185', '#f59e0b', '#38bdf8', '#a855f7', '#22c55e'];

export function useHearts() {
  const [floating, setFloating] = useState([]);
  const [count, setCount] = useState(0);
  const idRef = useRef(0);
  const pop = useCallback((n) => {
    const id = ++idRef.current;
    setFloating((f) => [...f.slice(-40), { id, x: 10 + Math.random() * 70, color: COLORS[id % COLORS.length], s: 18 + Math.random() * 18 }]);
    if (typeof n === 'number') setCount(n);
    setTimeout(() => setFloating((f) => f.filter((h) => h.id !== id)), 2600);
  }, []);
  return { floating, count, pop, setCount };
}

export function HeartsOverlay({ floating }) {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="hearts-overlay">
      {floating.map((h) => (
        <Heart key={h.id} className="absolute heart-float" fill={h.color} stroke={h.color}
          style={{ left: `${h.x}%`, bottom: '8%', width: h.s, height: h.s }} />
      ))}
    </div>
  );
}

export function HeartButton({ onSend, count }) {
  const [burst, setBurst] = useState(false);
  useEffect(() => { if (!burst) return; const t = setTimeout(() => setBurst(false), 200); return () => clearTimeout(t); }, [burst]);
  return (
    <button type="button" data-testid="heart-btn" onClick={() => { onSend(); setBurst(true); }}
      className={`absolute bottom-3 right-3 inline-flex items-center gap-1.5 px-3 py-2 rounded-full bg-rose-600/90 hover:bg-rose-500 text-white text-sm font-bold shadow-lg transition-transform ${burst ? 'scale-125' : 'scale-100'}`}>
      <Heart className="h-4 w-4" fill="white" />
      <span data-testid="heart-count">{count}</span>
    </button>
  );
}
